import { createSelector } from 'reselect';

import * as Store from 'store';

import * as Types from './types';

export const getList = createSelector<Store.Types.IState, Types.IEntity.Registry[], Types.IEntity.Registry[]>(
  (state => state.registry.list.items),
  (items) => items
);